import { formatString, getDomainLanguage } from "@/hooks/getDomain";
import { AppContext } from "@/pages/_app";
import { useContext, useEffect, useState } from "react";
import ReactCountryFlag from "react-country-flag";

export default function Footer({ pageProps }) {
  const { domain, countryCode, firstOfferId, store } = pageProps;
  const [subdomain, setSubdomain] = useState("");
  const { translation } = useContext(AppContext);

  useEffect(() => {
    if (typeof window === "undefined") return;

    // 1. Subdomain logic
    setSubdomain(window.location.href.split("//")[1].split(".")[0]);

    // a7.js and Modal.jsx now build affiliate URLs client-side from goid.
    // data-affiliate attributes contain only the goid (offer ID), not the full URL.
    // No post-render modification needed.
  }, [countryCode, domain, firstOfferId, store?.id]);

  return (
    <div className="mt-10 md:mt-16 bg-gray-850 text-white py-2.5 text-sm px-4 xl:px-0">
      <div className="inner-container flex flex-col md:flex- text-xs md:text-xs gap-2 justify-center items-center">
        {false && subdomain !== "www" && (
          <p dangerouslySetInnerHTML={{ __html: translation?.popularsites }}></p>
        )}
        <p className="flex items-center gap-2">
          <a href={`https://www.${domain}/stores-a-z`}>{translation?.abc_link_all}</a>
          <span dangerouslySetInnerHTML={{ __html: translation?.email }}></span>
        </p>
        <p className="flex items-center gap-2">
          <span
            dangerouslySetInnerHTML={{
              __html: translation?.copyright
                ? formatString(translation.copyright)
                : "",
            }}
          />
          {countryCode && (
            <ReactCountryFlag
              countryCode={countryCode}
              svg
              className="ml-2"
              alt={`flag ${countryCode}`}
            />
          )}
        </p>
        {domain === 'tipdeal.be' && (
          <p className="flex items-center gap-2 text-gray-500">
            <a href="https://www.startpagina.vlaanderen" rel="nofollow noopener" target="_blank" className="hover:text-gray-300 transition-colors">Startpagina Vlaanderen</a>
          </p>
        )}
      </div>
    </div>
  );
}